module.exports = __webpack_public_path__ + "img/rnd_pt_fine_bolt.prt.2a2c2fa8.jpg";